import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'ducks';

export type ChangeFrontsState = {
  keepGlassDoors?: boolean;
  keepSolidDoors?: boolean;
  keepOpenFrames?: boolean;
};

const initialState: ChangeFrontsState = {
  keepGlassDoors: undefined,
  keepSolidDoors: undefined,
  keepOpenFrames: undefined
};

const changeFrontsSlice = createSlice({
  name: 'changeFrontsSlice',
  initialState,
  reducers: {
    setKeepGlassDoors(state, action: PayloadAction<boolean>) {
      state.keepGlassDoors = action.payload;
    },
    setKeepSolidDoors(state, action: PayloadAction<boolean>) {
      state.keepSolidDoors = action.payload;
    },
    setKeepOpenFrames(state, action: PayloadAction<boolean>) {
      state.keepOpenFrames = action.payload;
    },
    resetChangeFrontChoices(state) {
      state.keepGlassDoors = undefined;
      state.keepSolidDoors = undefined;
      state.keepOpenFrames = undefined;
    }
  }
});

export const getChangeFrontState = (state: RootState) => state.changeFronts;

export const {
  setKeepGlassDoors,
  setKeepSolidDoors,
  setKeepOpenFrames,
  resetChangeFrontChoices
} = changeFrontsSlice.actions;
export default changeFrontsSlice.reducer;
